import React, { useState } from 'react';
import { ImFloppyDisk } from 'react-icons/im';
import {
  Button,
  Dropdown,
  TextArea,
  TextField,
  WrapperFlex,
} from '@unimed-fesp/components';
import { useField } from '@rocketseat/unform';
import history from '../../services/history';

const FormListaInativos = ({ lista }) => {
  const { registerField: registerModalidades } = useField('modalidade');
  const { registerField: registerDescricao } = useField('descricao');

  const [selectedTipo, setSelectedTipo] = useState('');

  const optionsTipoModalidade = [
    {
      onClickOption: () => handleSelectedTipo('36 - Demitidos'),
      text: '36 - Demitidos',
    },
    {
      onClickOption: () => handleSelectedTipo('38 - Aposentados'),
      text: '38 - Aposentados',
    },
  ];

  function handleSelectedTipo(texto) {
    setSelectedTipo(texto);
  }

  return (
    <div>
      <TextField
        name="nome"
        labelText="Lista"
        width={150}
        marginBottom={30}
        marginTop={5}
        placeholder="Id_Lista"
        font="13px 'Calibri Regular'"
        disabled
        value={lista?.nmLista}
      />
      <TextField
        name="Contratante"
        labelText="Nome da Contratante"
        width={400}
        marginBottom={30}
        marginTop={5}
        placeholder="Contrante"
        font="13px 'Calibri Regular'"
        disabled
        value={lista?.nmEmpresa}
      />
      <Dropdown
        tipo="dropdown"
        disable
        width={220}
        height={46}
        marginBottom={30}
        marginTop={9}
        labelText="Movimentação"
        name="movimentacao"
      >
        Inativos
      </Dropdown>
      <Dropdown
        options={optionsTipoModalidade}
        tipo="dropdown"
        width={220}
        height={46}
        marginBottom={30}
        marginTop={9}
        labelText="Modalidade"
        name="modalidade"
        register={registerModalidades}
      >
        {selectedTipo || 'Selecione a Modalidade'}
      </Dropdown>
      <TextArea
        labelText="Descrição"
        name="descricao"
        marginLeft={1}
        marginBottom={30}
        width={600}
        height={100}
        register={registerDescricao}
      />
      <WrapperFlex marginTop={30} justifySpaceBetween alignCenter>
        <Button
          tipo="tertiary"
          type="button"
          justifyCenter
          alignCenter
          width={100}
          font="16px unimed_slabregular"
          onClick={() => history.push('/novo/lista')}
        >
          cancelar
        </Button>
        <Button
          tipo="primary"
          width={100}
          paddingTop={1}
          paddingRight={1}
          paddingBottom={1}
          paddingLeft={1}
          font="16px unimed_slabregular"
          justifySpaceAround
          alignCenter
          type="submit"
          disabled={!selectedTipo}
          // onClick={handleUpdated}
        >
          <ImFloppyDisk />
          salvar
        </Button>
      </WrapperFlex>
    </div>
  );
};

export default FormListaInativos;
